<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 系统相关</el-breadcrumb-item>
                <el-breadcrumb-item>角色信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='14'>
                        <el-input v-model='query.name' class='handle-input mr10' placeholder='请输入角色'
                                  @keyup.enter.native='handleSearch'></el-input>
                        <el-button icon='el-icon-search' type='primary' @click='handleSearch'>搜索</el-button>
                    </el-col>
                    <el-col :span='10'>
                        <el-button icon='el-icon-upload2' style='float: right; margin-right: 20px' type='primary'
                                   @click='showInsertDialog()'>新增
                        </el-button>
                        <el-button icon='el-icon-s-custom' style='float: right; margin-right: 20px'
                                   type='primary'
                                   @click='handleAllRole'>分配权限
                        </el-button>
                    </el-col>
                </el-row>
            </div>
            
            <el-table
                v-loading='table.loading'
                :cell-style="{ textAlign: 'center' }"
                :data='table.tableData'
                :default-sort="{prop: 'createTime', order: 'descending'}"
                :header-cell-style="{textAlign: 'center'}"
                @selection-change='handleSelectionChange'
            >
                <el-table-column label='角色ID' prop='roleId' width='183px'></el-table-column>
                <el-table-column label='角色名称' prop='roleName'></el-table-column>
                <el-table-column align='center' class-name='small-padding fixed-width' label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='showEditDialog(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                        <el-button
                            icon='el-icon-circle-check'
                            size='mini'
                            type='text'
                            @click='handleRole(scope.row)'
                        >数据权限
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页导航 -->
            <div class='pagination'>
                <el-pagination
                    :current-page='table.pageIndex'
                    :page-size='table.pageSize'
                    :total='table.pageTotal'
                    background
                    layout='total, prev, pager, next'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>
        
        <!------------------------------------------------- 新增用户的对话框 -->
        <el-dialog
            :close-on-click-modal='false'
            :visible.sync='insertDialogVisible'
            title='新增角色'
            width='40%'
            @close='insertDialogClosed'>
            <el-input v-model='currentRole.roleName' placeholder='请输入角色名' />
            <span slot='footer' class='dialog-footer'>
            <el-button @click='insertDialogVisible = false'>取 消</el-button>
            <el-button :loading='this.postLoading' type='primary' @click='insertData'>确 定</el-button>
          </span>
        </el-dialog>
        
        <el-dialog
            :close-on-click-modal='false'
            :visible.sync='editMultipleDialogVisible'
            title='修改角色信息'
            width='40%'
            @close='editMultipleDialogClosed'>
            <el-input size='mini' v-model='currentRole.roleName' placeholder='update key' />
            <el-switch @change='handleChange' style='margin-top: 1rem; margin-bottom: 1rem;' active-text='管理员' inactive-text='非管理员' v-model='currentRole.administrator'/>
            <span slot='footer' class='dialog-footer'>
            <el-button @click='editMultipleDialogVisible = false'>取 消</el-button>
            <el-button type='primary' @click='updateRoleInfo'>确 定</el-button>
          </span>
        
        </el-dialog>
        
        <!--为角色分配权限-->
        <el-dialog
            :close-on-click-modal='false'
            @close='handlePermissionCancel'
            :visible.sync='permissionDialogVisible'
            :title='`操作 ${currentRole.roleName} 角色权限`'
            width='40%'>
            
            <el-tabs v-model='tabActiveName'>
                <el-tab-pane label="增加角色权限" name="addRolePermission">
                    <el-select multiple size='mini' v-model='newPermissionList' filterable
                               placeholder='请选择可访问的权限'>
                        <el-option
                            v-for='item in getAddablePermissionList'
                            :key='item.id'
                            :label='`${item.name}-${item.url}`'
                            :value='item.id'>
                        </el-option>
                    </el-select>
                </el-tab-pane>
                <el-tab-pane label="移除角色权限" name="deletePermission">
                    <el-table
                        :data='rolePermissionList'
                        style='width: 100%'
                        @selection-change='handlePermissionSelectionChange'>
                        <el-table-column
                            type='selection'
                            width='55'>
                        </el-table-column>
                        <el-table-column
                            prop='name'
                            label='url描述'>
                        </el-table-column>
                        <el-table-column
                            prop='url'
                            label='路径'>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            
            <span slot='footer' class='dialog-footer'>
            <el-button @click='handlePermissionCancel'>取 消</el-button>
            <el-button type='primary' @click='submitRoleInfo'>确 定</el-button>
          </span>
        
        </el-dialog>
    </section>
</template>

<script>
import { updateMultipleAntiProjectData } from '@api/antiaddiction';
import { deleteRole, insertRole, selectRoleList, updateRole } from '@/components/api/role';
import { message } from '@/utils/message';
import { selectPermissionList } from '@/components/api/permission';
import {
    deletePermissionsForRole,
    insertPermissionsForRoles,
    queryAllRolePermissionRelation
} from '@/components/api/rolePermission';

export default {
    name: 'AntiProjectData',
    data() {
        return {
            defaultProps: {
                children: 'children',
                label: 'label',
                value: 'value',
                url: 'url',
                addedDb: 'addedDb'
            },
            // 控制新增用户对话框的显示与隐藏，默认为隐藏
            insertDialogVisible: false,
            // 新增数据 对话框
            insertForm: {
                name: '',
                cnName: '',
                bizId: '',
                appId: '',
                secretKey: '',
                code: '',
                holiday: ''
            },
            // 新增数据按钮 等待响应动画
            postLoading: false,
            insertRole: {
                name: [{ required: true, message: '请输入项目名', trigger: 'blur' }]
            },
            
            // 控制修改用户对话框的显示与隐藏，默认为隐藏
            editDialogVisible: false,
            // 修改数据 对话框
            editForm: {
                name: '',
                cnName: '',
                bizId: '',
                appId: '',
                secretKey: '',
                code: '',
                holiday: ''
            },
            editRole: {
                name: [{ required: true, message: '请输入项目名', trigger: 'blur' }]
            },
            
            // 控制批量操作用户对话框的显示与隐藏，默认为隐藏
            editMultipleDialogVisible: false,
            // 批量操作集合
            multipleSelection: [],
            //批量操作 对话框
            editMultipleForm: {
                secretKey: ''
            },
            
            // 查询条件
            query: {
                addProjectName: '', //新增项目名
                name: ''           //搜索框
            },
            // 表单数据
            table: {
                tableData: [],
                pageIndex: 1,   // 页码
                pageTotal: 0,   // 总数据量
                pageSize: 0,    // 单页数据量
                loading: false  // 加载动画
            },
            currentRole: {},
            // 后端接口集合
            permissionList: [],
            permissionDialogVisible: false,
            selectRoleList: [],
            selectPermissionList: [],
            tabActiveName: 'addRolePermission',
            apiInfoTreeOptions: [],
            allApiInfoList: [],
            rolePermissionList: [],
            checkPermissionList: [],
            addTreeFilterText: undefined,
            removeTreeFilterText: undefined,
            allPermissionList: [],
            
            newPermissionList: [],
            removePermissionList: []
        };
    },
    watch: {
        addTreeFilterText(val) {
            this.$refs.addTree.filter(val)
        },
        removeTreeFilterText(val) {
            this.$refs.removeTree.filter(val)
        },
    },
    computed: {
        getAddablePermissionList() {
            const addedIds = this.rolePermissionList.map(item => item.id);
            return this.permissionList.filter(item => !addedIds.includes(item.id));
        }
    },
    created() {
        this.getRoleInfo();
    },
    activated() {
        this.getRoleInfo();
    },
    methods: {
        handleChoseAll(treeName) {
            // removeTree addTree
            let treeNode = undefined
            if (treeName === 'removeTree') {
                treeNode = this.$refs.removeTree
            }else {
                treeNode = this.$refs.addTree
            }
            this.apiInfoTreeOptions.forEach((api, index) => {
                if (api.children) {
                    api.children.forEach((child, childIndex) => {
                        if (!child.disabled) {
                            let arr = treeNode.getCheckedKeys()
                            arr.push(child.url)
                            treeNode.setCheckedKeys(arr)
                        }
                    })
                }
            })
        },
        handleAddRoleFilterNode(value, data) {
            if (!value) return true;
            return data.url.indexOf(value) !== -1;
        },
        handleRemoveRoleFilterNode(value, data) {
            if (!value) return true;
            return data.url.indexOf(value) !== -1;
        },
        handleRenderContent(h, { node, data, store }) {
            if (!data.children) {
                return (<el-tooltip className='item' effect='dark' placement='right'>
                    <template slot='content'>{data.url}</template>
                    <span>{node.label}</span></el-tooltip>);
            }
            return (<span>{node.label}</span>);
        },
        handlePermissionCancel() {
            this.permissionDialogVisible = false
            this.currentRole = {}
            this.newPermissionList = [];
        },
        // 添加或者移除权限
        submitRoleInfo() {
            if (this.tabActiveName === 'addRolePermission') {
                if (!this.newPermissionList) {
                    message.error('请选择权限');
                    return;
                }
                
                const newPermissionObjs = this.newPermissionList.map(t => ({ id: t }));
                insertPermissionsForRoles([this.currentRole], newPermissionObjs).then(result => {
                    if (result.code !== 200) {
                        message.error(result.message);
                        return;
                    }
                    message.success('添加权限成功');
                    this.permissionDialogVisible = false;
                    this.newPermissionList = [];
                })
            }else {
                if (!this.removePermissionList) {
                    message.error('请选择需要移除的url');
                    return;
                }
                deletePermissionsForRole([this.currentRole], this.removePermissionList).then(result => {
                    if (result.code !== 200) {
                        message.error(result.message);
                        return;
                    }
                    message.success(result.message);
                    this.permissionDialogVisible = false;
                    this.removePermissionList = [];
                })
            }
        },
        handleAllRole() {
            this.permissionDialogVisible = true
            this.tabActiveName = 'addRolePermission'
        },
        handleRole(role) {
            console.log(role);
            this.currentRole = role
            this.permissionDialogVisible = true
            this.tabActiveName = 'addRolePermission';
            
            // 查询此角色权限
            this.queryRolePermission();
        },
        // 项目名称信息
        getRoleInfo() {
            this.table.loading = true;
            let roleName = this.query.name;
            // 发送请求
            selectRoleList(null, roleName, 1).then(result => {
                if (result.data) {
                    this.table.tableData = result.data.result;
                    this.table.pageTotal = result.data.total;
                    this.table.pageSize = result.data.pageSize;
                    if (!this.table.pageSize) {
                        this.table.pageSize = 15;
                    }
                    this.table.loading = false;
                } else {
                    message.error(result.message);
                    this.table.loading = false;
                }
            });
            
            selectPermissionList(null, null, null, null, 100000).then(result => {
                if (result.data && result.data.result) {
                    this.permissionList = result.data.result
                }
            })
        },
        
        // 触发搜索按钮
        handleSearch() {
            this.table.pageIndex = 1;
            this.getRoleInfo();
        },
        
        // 展示新增AntiProjectData对话框
        showInsertDialog() {
            this.insertDialogVisible = true;
        },
        
        // 新增form表单
        insertData() {
            console.log(this.currentRole);
            if (!this.currentRole.roleName) {
                message.error('请输入角色名');
                return;
            }
            insertRole(this.currentRole.roleName).then(result => {
                if (result.code === 200) {
                    message.success('添加成功');
                    this.insertDialogVisible = false;
                    this.postLoading = false;
                    this.getRoleInfo();
                    this.currentRole = {};
                } else {
                    message.error(result.message);
                }
            });
        },
        
        // 监听新增AntiProjectData对话框的关闭
        insertDialogClosed() {
            this.$refs.insertFormRef.resetFields();
        },
        
        // 展示编辑用户的对话框
        showEditDialog(role) {
            this.editMultipleDialogVisible = true;
            this.currentRole = role;
        },
        handleDelete(role) {
            let obj = this
            this.$modal.confirm('是否确认删除角色"' + role.roleName + '"的数据项？').then(function() {
                return deleteRole(role.roleId);
            }).then((result) => {
                if (result.code === 200) {
                    this.$modal.msgSuccess('删除成功');
                    obj.getRoleInfo()
                }else {
                    message.error(result.message)
                }
            }).catch(() => {
            });
        },
        handleChange() {
            console.log(this.currentRole);
        },
        // 修改角色信息
        updateRoleInfo() {
            if (!this.currentRole.roleName) {
                message.warning('角色名不能为空');
                return;
            }
            updateRole(this.currentRole).then(result => {
                if (result.code !== 200) {
                    message.error(result.message);
                    return
                }
                this.insertDialogVisible = false;
                this.postLoading = false;
                this.getRoleInfo();
                this.currentRole = {};
                message.success(result.message);
                this.editMultipleDialogVisible = false
            });
            this.$refs.editMultipleFormRef.validate(valid => {
                // 替换集合中的 secretKey
                this.multipleSelection.forEach((item, index) => {
                    item.secretKey = this.editMultipleForm.secretKey;
                });
                
                let params = JSON.stringify(this.multipleSelection);
                updateMultipleAntiProjectData(params).then(res => {
                    let result = JSON.parse(res.data);
                    if (result.code === 200) {
                        // 修改成功, 更新页面
                        this.getAntiProjectData();
                        
                        this.$message({
                            showClose: true,
                            message: '共' + this.multipleSelection.length + '条数据, 成功' + result.data + '条',
                            type: 'success'
                        });
                        this.editMultipleDialogVisible = false;
                    } else {
                        this.$message.error('修改失败');
                    }
                });
            });
        },
        
        // 分页导航
        handlePageChange(val) {
            this.table.pageIndex = val;
            this.getAntiProjectData();
        },
        
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        
        // 监听修改多选用户对话框关闭
        editMultipleDialogClosed() {
            this.$refs.editMultipleFormRef.resetFields();
        },
        async queryRolePermission() {
            this.rolePermissionList = [];
            let result = await queryAllRolePermissionRelation([{ roleId: this.currentRole.roleId }]);
            if (result.data) {
                let rolePermissionsMap = result.data.rolePermissionsMap
                for (let role in rolePermissionsMap) {
                    if (rolePermissionsMap[role]) {
                        for (let i = 0; i < rolePermissionsMap[role].length; i++) {
                            this.rolePermissionList.push(rolePermissionsMap[role][i]);
                            if (i === rolePermissionsMap[role].length - 1) {
                                console.log(this.rolePermissionList);
                                return this.rolePermissionList;
                            }
                        }
                    }
                }
            }
            return this.rolePermissionList;
        },
        handlePermissionSelectionChange(val) {
            this.removePermissionList = val;
        }
    }
};
</script>

<style lang='scss' scoped>
.handle-input {
    width: 260px;
    display: inline-block;
    margin-right: 10px;
}
</style>
